module.exports = __webpack_public_path__ + "static/media/微波目标特性测量实验室1.aad3d51e.jpg";